import React from 'react';
import { Dialog, DialogContent, Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ConfirmDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
  loading?: boolean;
}

const ConfirmDeleteModal = ({
  open,
  onClose,
  onConfirm,
  title = 'Excluir QR Code?',
  description = 'Esta ação não pode ser desfeita. O QRCode será removido permanentemente.',
  loading = false,
}: ConfirmDeleteModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          paddingTop: 2,
        },
      }}
    >
      <DialogContent sx={{ px: 4, pb: 4 }}>
        <Box position="relative" display="flex" alignItems="center" justifyContent="center" mb={2}>
          <Typography fontWeight={600} fontSize={18}>
            {title}
          </Typography>
          <IconButton onClick={onClose} size="small" disabled={loading} sx={{ position: 'absolute', right: 0 }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box display="flex" flexDirection="column" alignItems="center" textAlign="center" mb={3}>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Box>

        <Box display="flex" gap={2}>
          <Button
            fullWidth
            variant="outlined"
            onClick={onClose}
            disabled={loading}
            sx={{
              borderRadius: '999px',
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Cancelar
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="error"
            onClick={onConfirm}
            disabled={loading}
            sx={{
              borderRadius: '999px',
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            {loading ? 'Excluindo...' : 'Excluir QRCode'}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
